// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1qy1D","title":"styles_title__DbZ-R","text":"styles_text__38qvc","image":"styles_image__1Gzw_"};